import { styled } from '@mui/material/styles'
import { Button, themeSpacing, Typography } from 'eezy-components'
import { useTranslation } from 'react-i18next'

const NotFound = () => {
  const { t } = useTranslation()
  return (
    <Container>
      <Title variant="h5">{t('page_not_found.title')}</Title>
      <Button color="primary">{t('page_not_found.go_back_home')}</Button>
    </Container>
  )
}

export default NotFound

const Container = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100%;
`

const Title = styled(Typography)`
  margin-bottom: ${themeSpacing(2)};
`
